export default {
    title_list: 'Промо коды',
    title_page: 'Промо код',
    title_create_page: 'Создать промо код',
    title_edit_page: 'Изменить промо код',

    filter: {
        labels: {
            code: 'Промо код',
        }
    },

    table: {
        labels: {
            id: 'ID',
            code: 'Промо код',
            date_start: 'Дата начала',
            date_finish: 'Дата окончания',
            counter: 'Количество использований',
            activated: 'Активен',
        }
    },

    buttons: {
        generate: 'Сгенерировать код',
        generateQRCode: 'Сгенерировать QR код'
    },

    form: {
        code: 'Промо код',
        parent_id: 'Пользователь',
        date_start: 'Дата начала',
        date_finish: 'Дата окончания',
        sale: 'Скидка (%)',
        activated: 'Активен',
        description: 'Описание (будет видно пользователю после ввода промокода)',
        note: 'Примечание',
        max_count: 'Лимит использований',
        counter: 'Количество использований',
        plan_id: 'Тарифный план',
        amount: 'Скидка ($)',
    },
}
